export default {
  subTaskSelectedIndex: -1, //鼠标点击选中的子任务索引
  uavData: {}, //控制面板上面的遥测信息
}